module.exports = __webpack_public_path__ + "img/demo_nightclub.6bdf7f7d.jpg";